import withPurchaseTimerContainer from './withPurchaseTimerContainer';

export default withPurchaseTimerContainer;
